import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }: Props) => (
    <svg
        className={`${className} ${styles.detailsIcon}`}
        data-testid={testId}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        viewBox="0 0 24 24"
    >
        <rect height="22" rx="2" width="18" x="3" y="1" />

        <path d="M14 1L21 8" />

        <line x1="14" x2="14" y1="1" y2="8" />

        <line x1="14" x2="21" y1="8" y2="8" />

        <line x1="7" x2="17" y1="13" y2="13" />

        <line x1="7" x2="17" y1="17" y2="17" />
    </svg>
);

export default DetailsIcon;
